import { render, staticRenderFns } from "./Risks.vue?vue&type=template&id=0a205144&"
import script from "./Risks.vue?vue&type=script&lang=js&"
export * from "./Risks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports